import { render, staticRenderFns } from "./AddNewSupplier.vue?vue&type=template&id=67b573a7&lang=html&"
import script from "./AddNewSupplier.vue?vue&type=script&lang=js&"
export * from "./AddNewSupplier.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSupplier.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports